import { useProgress } from "@react-three/drei";

/**
 * The See model is ~12 MB. A spinner with no number reads as "stuck" on a
 * slow connection, so show real progress and name what is loading — the
 * difference between waiting and wondering whether it is broken.
 */
export function AssetProgress() {
  const { active, progress, item } = useProgress();

  if (!active) return null;

  const percent = Math.min(99, Math.round(progress));

  return (
    <div className="asset-progress" role="status" aria-live="polite" data-testid="asset-progress">
      <div className="asset-progress-track">
        <span className="asset-progress-bar" style={{ width: `${percent}%` }} />
      </div>
      <p>
        Loading the experience · {percent}%
        {item ? <span className="asset-progress-item">{shortName(item)}</span> : null}
      </p>
    </div>
  );
}

function shortName(item: string): string {
  const name = item.split("/").pop() ?? item;
  return name.length > 34 ? `${name.slice(0, 31)}…` : name;
}
